import { useState } from 'react';

import { ICompany } from 'types/company';

import { useGlobalKeyDown } from 'hooks/browser/keyPress';
import { useUpdateStory } from 'hooks/stories/firebase/update';

export const useToggleUI = (initial: boolean = false) => {
  const [isActive, setIsActive] = useState(initial);
  useGlobalKeyDown(() => setIsActive(false), 'Escape');

  const setActive = () => setIsActive(true);
  const setInactive = () => setIsActive(false);

  return { isActive, setActive, setInactive };
};

export const useStory = ({
  company,
  draftId,
}: {
  company: ICompany;
  draftId: string | null;
}) => {
  const { error, initialData, isLoading, handleSubmit } = useUpdateStory(
    company.slug,
    draftId,
  );

  return {
    error,
    initialData,
    isLoading,
    handleSubmit,
  };
};
